# Generated from app.intent.md — do not edit manually
# Route: /materials/classes
# Audience: MES Engineers (md+), blocked on sm
# Ref: app.intent.md § Material Classes

page-class-list:
  type: Page
  archetype: list
  meta:
    title: $t.class_list.meta_title
    auth: required
  data:
    classes:
      model: ItemClass[]
      refresh: on_mount
  spatial:
    display: flex
    direction: column
    gap: $spacing.lg
    padding: $spacing.lg
    padding_inline: $spacing.xl
    overflow: auto
  tokens:
    background: $color_scheme.light.color.surface
  children:
    - class-list-sm-notice
    - class-list-content

# ── sm viewport notice ───────────────────────────────────────────────────────

class-list-sm-notice:
  type: SmNotice
  content: $t.common.sm_notice_class

# ── Main content (hidden on sm) ──────────────────────────────────────────────

class-list-content:
  type: Section
  spatial:
    display: flex
    direction: column
    gap: $spacing.lg
    responsive:
      sm:
        display: none
  children:
    - class-list-header
    - class-list-table

# ── Header ───────────────────────────────────────────────────────────────────

class-list-header:
  type: PageHeader
  content: $t.class_list.title
  actions:
    - label: $t.class_list.btn_create
      route: /materials/classes/new
      color: info
      # F79 — Cancel / on_success on the create screen returns to this list.
      return_context: origin_only

# ── Class table ──────────────────────────────────────────────────────────────

class-list-table:
  type: Table
  bind:
    rows: classes
  empty: class-list-empty
  columns:
    - key: name
      label: $t.class_list.col_name
      tokens:
        font_size: $font.size.sm
    - key: itemNature
      label: $t.class_list.col_nature
      tokens:
        font_size: $font.size.sm
    - key: defaultTrackingMode
      label: $t.class_list.col_tracking
      tokens:
        font_size: $font.size.sm
    - key: parentClassId
      label: $t.class_list.col_parent
      tokens:
        font_size: $font.size.sm
        color: $color_scheme.light.color.on-surface-muted
  # F75 #134 (AC-C3) — row click navigates to the read-only class detail page.
  row_action:
    type: navigate
    route: /materials/classes/:id
    params:
      id: $row.id
  a11y:
    label: $t.class_list.table_label
  spatial:
    width: 100%
  tokens:
    border: $border.default
    radius: $radius.md
    background: $color_scheme.light.color.surface-elevated

class-list-empty:
  type: EmptyState
  content: $t.class_list.empty
  body: $t.class_list.empty_body
  tokens:
    color: $color_scheme.light.color.on-surface-muted
    font_size: $font.size.md
  spatial:
    padding: $spacing.lg
